import { HTMLAttributes } from "react";

interface SparkleIconProps extends HTMLAttributes<SVGElement> {}

const SparkleIcon = ({ ...props }: SparkleIconProps) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5978 27.7826C16.963 20.6087 20.25 17.3478 27.0326 17.3478C27.3785 17.3478 27.7103 17.2104 27.9549 16.9658C28.1995 16.7212 28.337 16.3894 28.337 16.0435C28.337 15.6975 28.1995 15.3658 27.9549 15.1212C27.7103 14.8766 27.3785 14.7391 27.0326 14.7391C19.8587 14.5826 16.5978 11.2696 16.5978 4.30435C16.5978 3.95841 16.4604 3.62665 16.2158 3.38203C15.9712 3.13742 15.6394 3 15.2935 3C14.9475 3 14.6158 3.13742 14.3712 3.38203C14.1266 3.62665 13.9891 3.95841 13.9891 4.30435C13.9891 11.3217 10.65 14.7391 3.55435 14.7391C3.20841 14.7391 2.87665 14.8766 2.63203 15.1212C2.38742 15.3658 2.25 15.6975 2.25 16.0435C2.25 16.3894 2.38742 16.7212 2.63203 16.9658C2.87665 17.2104 3.20841 17.3478 3.55435 17.3478C10.5978 17.3478 13.9891 20.6609 13.9891 27.7826C13.9955 28.1221 14.1315 28.4463 14.3691 28.6887C14.6068 28.9312 14.9281 29.0737 15.2674 29.087C15.4409 29.0904 15.6133 29.0593 15.7746 28.9953C15.9358 28.9313 16.0827 28.8357 16.2066 28.7143C16.3305 28.5928 16.4289 28.4478 16.4961 28.2879C16.5633 28.1279 16.5979 27.9561 16.5978 27.7826Z"
        fill="#FFD53F"
      />
      <line
        x1="27"
        y1="32"
        x2="27"
        y2="22"
        stroke="#FFD53F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="32"
        y1="27"
        x2="22"
        y2="27"
        stroke="#FFD53F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SparkleIcon;
